import {
  LabExternalStorageProvider,
  LabExternalStorageProviderCreate,
  LabExternalStorageProviderUpdate,
  LabExternalStorageProviderValidationRequest,
  LabExternalStorageProviderValidationResult,
} from 'interfaces/externalStorage';
import { apiRequestHandlerPromise } from 'utils/apiRequestHandler';

const providerUrl = (labId: string, providerName?: string) =>
  `labs/${labId}/external-storage-providers${providerName ? `/${encodeURIComponent(providerName)}` : ''}`;

export const labExternalStorageProvidersQueryKey = (labId: string) => ['lab-external-storage-providers', labId];

export const getLabExternalStorageProviders = (labId: string, signal?: AbortSignal) =>
  apiRequestHandlerPromise<LabExternalStorageProvider[]>({
    url: providerUrl(labId),
    method: 'GET',
    signal,
  });

export const createLabExternalStorageProvider = (labId: string, data: LabExternalStorageProviderCreate) =>
  apiRequestHandlerPromise<LabExternalStorageProvider>({
    url: providerUrl(labId),
    method: 'POST',
    data: JSON.stringify(data),
  });

export const updateLabExternalStorageProvider = (
  labId: string,
  providerName: string,
  data: LabExternalStorageProviderUpdate
) =>
  apiRequestHandlerPromise<LabExternalStorageProvider>({
    url: providerUrl(labId, providerName),
    method: 'PATCH',
    data: JSON.stringify(data),
  });

export const disableLabExternalStorageProvider = (labId: string, providerName: string) =>
  apiRequestHandlerPromise<LabExternalStorageProvider>({
    url: `${providerUrl(labId, providerName)}/disable`,
    method: 'POST',
  });

export const validateLabExternalStorageProvider = (
  labId: string,
  providerName: string,
  data: LabExternalStorageProviderValidationRequest
) =>
  apiRequestHandlerPromise<LabExternalStorageProviderValidationResult>({
    url: `${providerUrl(labId, providerName)}/validate`,
    method: 'POST',
    data: JSON.stringify(data),
  });

export const renameLabExternalStorageProvider = (labId: string, providerName: string, newName: string) =>
  apiRequestHandlerPromise<LabExternalStorageProvider>({
    url: `${providerUrl(labId, providerName)}/rename`,
    method: 'POST',
    data: JSON.stringify({ newName }),
  });
